const fr = {
  // Common
  save: "Sauvegarder",
  cancel: "Annuler",
  delete: "Supprimer",
  edit: "Modifier",
  search: "Rechercher",
  loading: "Chargement...",
  noData: "Aucune donnée",
  download: "Télécharger",
  upload: "Envoyer",
  back: "Retour",
  close: "Fermer",
  confirm: "Confirmer",
  create: "Créer",
  view: "Voir",
  all: "Tous",
  active: "Actif",
  archived: "Archivé",
  draft: "Brouillon",
  published: "Publié",

  // Auth
  login: "Connexion",
  logout: "Déconnexion",
  loginWithGoogle: "Continuer avec Google",
  email: "Email",
  password: "Mot de passe",
  forgotPassword: "Mot de passe oublié ?",

  // Navigation - Learner
  nav_home: "Accueil",
  nav_sequences: "Séquences e-learning",
  nav_progress: "Suivi pédagogique",
  nav_program: "Programme",
  nav_learners: "Apprenants",
  nav_attendance: "Émargements",
  nav_evaluations: "Évaluations",
  nav_documents: "Documents",
  nav_certificates: "Certificats",
  nav_badges: "Badges & XP",
  nav_about: "À propos",
  nav_sessions: "Accès à vos sessions :",
  nav_selectSession: "Sélectionner une session",
  nav_learnerSpace: "Espace apprenant",

  // Navigation - Admin
  nav_dashboard: "Tableau de bord",
  nav_agenda: "Agenda",
  nav_commercial: "Commercial",
  nav_salesFunnel: "Tunnel de vente",
  nav_registrations: "Inscriptions",
  nav_trainingSessions: "Sessions de formation",
  nav_allSessions: "Toutes les sessions",
  nav_archivedSessions: "Sessions archivées",
  nav_elearning: "E-learning",
  nav_elearningDashboard: "Dashboard e-learning",
  nav_courses: "Parcours",
  nav_sequencesAdmin: "Séquences",
  nav_activities: "Activités",
  nav_scorm: "Modules SCORM",
  nav_aiQuiz: "Quiz IA",
  nav_library: "Bibliothèque",
  nav_programs: "Programmes",
  nav_evalsAdmin: "Évaluations",
  nav_archives: "Archives",
  nav_reports: "Rapports",
  nav_activityReport: "Suivi de l'activité",
  nav_invoices: "Suivi des factures",
  nav_commercialReport: "Suivi commercial",
  nav_bpf: "Bilan pédagogique",
  nav_quality: "Suivi qualité",
  nav_improvement: "Amélioration continue",
  nav_marketplace: "Marketplace",
  nav_data: "Données",
  nav_companies: "Entreprises",
  nav_students: "Apprenants",
  nav_trainers: "Intervenants",
  nav_funders: "Financeurs",
  nav_locations: "Lieux",
  nav_settings: "Paramètres",

  // Dashboard - Learner
  dash_sessionTitle: "Session de formation",
  dash_elearning: "E-learning",
  dash_progressLabel: "de progression",
  dash_accessElearning: "Accéder au e-learning",
  dash_attendance: "Émargements",
  dash_pendingSignatures: "signature(s) en attente",
  dash_noPending: "Aucun émargement en attente",
  dash_sign: "Signer",
  dash_rules: "Règlement intérieur",
  dash_trainers: "Vos intervenants",
  dash_discoverTrainers: "Découvrez vos formateurs",
  dash_calendar: "Calendrier",
  dash_trainingSlots: "Vos créneaux de formation",
  dash_nextSlot: "Prochain créneau",
  dash_today: "Aujourd'hui",

  // Gamification
  gam_level: "Niveau",
  gam_xpTotal: "XP au total",
  gam_badgesEarned: "badges obtenus",
  gam_progressToNext: "Progression vers niveau",
  gam_badges: "Badges",
  gam_leaderboard: "Classement",
  gam_leaderboardTitle: "Classement des apprenants",
  gam_noLeaderboard: "Aucun classement disponible",
  gam_you: "(vous)",
  gam_viewAll: "Voir tout",
  gam_earnXP: "Gagnez des points XP et débloquez des badges",
  gam_myBadges: "Mes badges & progression",

  // Certificates
  cert_title: "Mes certificats",
  cert_subtitle: "Vos certificats de formation",
  cert_generate: "Obtenir le certificat",
  cert_download: "Télécharger PDF",
  cert_sendEmail: "Envoyer par email",
  cert_generated: "Certificat généré ! Un email avec le PDF vous a été envoyé.",
  cert_resent: "Certificat renvoyé par email !",
  cert_eligible: "Éligible",
  cert_notEligible: "Non éligible",

  // Documents
  doc_title: "Documents",
  doc_subtitle: "Documents de la session :",
  doc_uploadBtn: "Envoyer un document",
  doc_uploading: "Envoi en cours...",
  doc_dragDrop: "Glissez-déposez ou cliquez pour envoyer un fichier",
  doc_formats: "PDF, Word, Excel, Images - Max 50 Mo",
  doc_platform: "Documents plateforme",
  doc_uploaded: "Fichiers envoyés",
  doc_total: "Total",
  doc_noDocuments: "Aucun document",
  doc_noDocDesc: "Envoyez un document ou attendez que votre formateur en partage",

  // Settings
  settings_title: "Paramètres",
  settings_subtitle: "Configurez votre plateforme de formation",
  settings_organism: "Organisme",
  settings_email: "Email",
  settings_theme: "Thème",
  settings_security: "Sécurité",
  settings_orgName: "Nom de l'organisme",
  settings_orgFull: "Nom complet",
  settings_emailContact: "Email de contact",
  settings_phone: "Téléphone",
  settings_address: "Adresse",
  settings_saved: "Paramètres sauvegardés",

  // Reports
  reports_activity: "Suivi de l'activité",
  reports_activityDesc: "Vue d'ensemble de l'activité de formation",
  reports_formations: "Formations",
  reports_students: "Apprenants",
  reports_sessions: "Sessions",
  reports_certificates: "Certificats",
  reports_completionRate: "Taux de complétion par formation",
  reports_keyIndicators: "Indicateurs clés",
  reports_overview: "Vue d'ensemble",
  reports_exports: "Exports disponibles",
  reports_attendanceRate: "Taux de présence",
  reports_evalCompleted: "Évaluations complétées",
  reports_activeEnrollments: "Inscriptions actives",
  reports_availableDocs: "Documents disponibles",

  // About
  about_title: "À propos",
  about_subtitle: "Informations sur votre organisme de formation",
  about_mission: "Notre mission",
  about_missionText: "AFFEA accompagne les professionnels de l'éducation et de la formation dans le développement de leurs compétences pédagogiques.",
  about_qualiopi: "Certification Qualiopi",
  about_qualiopiDesc: "Organisme certifié, garantissant la qualité de nos processus de formation",
  about_accessibility: "Accessibilité",
  about_accessibilityDesc: "Engagé dans la démarche d'accessibilité de nos formations",
  about_contact: "Nous contacter",
  about_handicap: "Référent handicap",

  // AFFEA Accessibility content
  affea_commitment: "est engagé dans la démarche d'accessibilité de ses formations",
  affea_measure: "Nous mesurons régulièrement le niveau d'accessibilité de nos formations et nous nous engageons sur des actions concrètes d'amélioration.",
  affea_engagements: "Nos engagements :",
  affea_eng1: "Modifier mon questionnaire situation de handicap pour le rendre plus précis par rapport à la RQTH",
  affea_eng2: "Organiser des entretiens téléphoniques de positionnement pour adapter mon intervention en amont",
  affea_eng3: "Organiser les compensations en vue d'améliorer l'accessibilité aux sessions pour les personnes porteuses de handicap",
  affea_progress: "Nos axes de progrès :",
  affea_prog1: "Améliorer ma démarche d'accueil et d'accompagnement des apprenants en situation de handicap",
  affea_prog2: "Rendre accessible pour tous nos informations et contenus pédagogiques",
  affea_prog3: "Mieux repérer et identifier les apprenants en situation de handicap largement avant le début de la formation",
  affea_questions: "Des questions ?",
  affea_contactRef: "Contactez notre référent handicap :",

  // Login
  login_welcome: "Bienvenue",
  login_subtitle: "Connectez-vous pour accéder à vos formations et suivre votre progression.",
  login_demo: "Accès démo",
  login_learner: "Apprenant",
  login_trainer: "Formateur",
  login_admin: "Admin",
  login_terms: "En vous connectant, vous acceptez nos",
  login_termsLink: "conditions d'utilisation",
  login_privacyLink: "politique de confidentialité",

  // Misc
  languageToggle: "Changer de langue",
  notifications: "Notifications",
  markAllRead: "Tout marquer lu",
  noNotifications: "Aucune notification",
};

export default fr;
